var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"board-info-card",on:{"click":_vm.selectBoard}},[_c('img',{staticClass:"board-info-card__operator-image",attrs:{"src":_vm.item.logo,"alt":"Operator"}}),_vm._v(" "),_c('div',{staticClass:"board-info-card__text"},[_c('p',{staticClass:"board-info-card__text__number"},[_vm._v(_vm._s(_vm.item.name))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-38a81eb5","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./src/components/BoardItemWeb/component.html
// module id = null
// module chunks = 